export function wasDrawerDismissedToday(congenereDrawerDismissedDate: string): boolean {
	const dismissedDate = congenereDrawerDismissedDate;
	if (!dismissedDate) return false;
	return dismissedDate === new Date().toDateString();
}
